import { useContext, useEffect, useState, useRef } from "react"
import { UserContext } from "../../store/store"

import { Link } from "react-router-dom"

import { setCookie } from "../../helpers/cookies"
import { meets } from "../../helpers/jwt"

import { useTranslation } from "react-i18next"

const UserMenu = (props) => {
  const [, dispatch] = useContext(UserContext)
  const [menu, setMenu] = useState(false)
  const btnEl = useRef()
  const menuEl = useRef()

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)

    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const handleClickOutside = (event) => {
    let clickedOutside = !(
      btnEl.current === event.target ||
      event.target.offsetParent === menuEl.current
    )
    if (clickedOutside) setMenu(false)
  }

  const handleLogOut = (e) => {
    e.preventDefault()
    dispatch({ type: "LOGOUT" })
    setCookie("jwt", "", 0)
    setCookie("username", "", 0)
    setCookie("role", "", 0)
  }

  const toggleMenu = (e) => {
    e.preventDefault()
    setMenu(!menu)
  }

  const { t } = useTranslation()

  return (
    <>
      <button
        className="btn link"
        id="usr-name"
        ref={btnEl}
        onClick={toggleMenu.bind(this)}>
        {props.name} {menu ? "▲" : "▼"}
      </button>
      {menu && (
        <ul className="usr-menu" ref={menuEl}>
          {meets(["admin", "teacher"]) && (
            <>
              <li>
                <Link to="/admin">👷 {t("index.header.menu.admin")}</Link>
              </li>
            </>
          )}

          <li>
            <Link to="/home" onClick={handleLogOut.bind(this)}>
              🚪 {t("index.header.menu.log_out")}
            </Link>
          </li>
        </ul>
      )}
    </>
  )
}

const LogInButton = () => {
  const { t } = useTranslation()
  return (
    <Link to="/login">
      <button className="btn vacio">{t("index.header.login")}</button>
    </Link>
  )
}

const Header = () => {
  const [state] = useContext(UserContext)
  const { t } = useTranslation()

  return (
    <nav>
      <div className="container">
        <div className="left-side">
          <Link to="/" className="navbar-brand">
            {t("index.header.title")}
          </Link>
          <span>{t("index.header.subtitle")}</span>
        </div>

        <div>
          {state.jwt ? <UserMenu name={state.usr.name} /> : <LogInButton />}
        </div>
      </div>
    </nav>
  )
}

export default Header
